export default __webpack_public_path__ + "static/media/FortKnoxster.fb9866e5.svg";